var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubsocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    opacity: 0.65,
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12.2765C22 17.7994 17.5229 22.2765 12 22.2765C6.47715 22.2765 2 17.7994 2 12.2765C2 6.75364 6.47715 2.27649 12 2.27649C17.5229 2.27649 22 6.75364 22 12.2765ZM11.9659 4.40908C9.92247 4.40908 8.26592 6.06562 8.26592 8.10908V10.5091C8.26592 12.5526 9.92247 14.2091 11.9659 14.2091C12.2527 14.2091 12.5319 14.1764 12.8 14.1147C12.961 14.0776 13.0061 13.8789 12.8867 13.7648L12.8667 13.7457L10.7351 11.7098C10.4046 11.3888 10.1993 10.9396 10.1993 10.4424V8.17574C10.1993 7.20004 10.9902 6.40908 11.9659 6.40908C12.9416 6.40908 13.7326 7.20004 13.7326 8.17574V8.94316C13.7326 9.09042 13.852 9.20982 13.9993 9.20982H15.3993C15.5465 9.20982 15.6659 9.09042 15.6659 8.94316V8.10908C15.6659 6.06562 14.0094 4.40908 11.9659 4.40908ZM15.6667 16.2432C15.6667 18.2866 14.0101 19.9432 11.9667 19.9432C9.9232 19.9432 8.26667 18.2866 8.26667 16.2432V15.4098C8.26667 15.2626 8.38606 15.1432 8.53333 15.1432H9.93333C10.0806 15.1432 10.2 15.2626 10.2 15.4098V16.1765C10.2 17.1522 10.9909 17.9432 11.9667 17.9432C12.9424 17.9432 13.7333 17.1522 13.7333 16.1765V13.9098C13.7333 13.4126 13.5279 12.9634 13.1974 12.6424L11.0659 10.6066L11.0459 10.5874C10.9264 10.4733 10.9716 10.2746 11.1326 10.2376C11.4007 10.1758 11.6799 10.1432 11.9667 10.1432C14.0101 10.1432 15.6667 11.7997 15.6667 13.8432V16.2432Z",
    fill: "#FFFFFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubsocial);
export default __webpack_public_path__ + "static/media/subsocial.965e7f97dd06125058de83b6ebccda39.svg";
export { ForwardRef as ReactComponent };